export const DATE_FORMATS = {
  AM_PM: 'MM/dd/yyyy h:mm a',
};
